var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKuriatko(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.37 75.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.04,37.97C6.29,37.97,0,31.68,0,23.92h14.04s0,14.04,0,14.04Z",
    style: {
      fill: "#fde047"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,52.01c0-7.76,6.29-14.04,14.04-14.04v14.04s-14.04,0-14.04,0Z",
    style: {
      fill: "#fde047"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.44,0v75.93s75.93,0,75.93,0C92.37,34,58.37,0,16.44,0Zm7.49,23.92c0-7.76,6.29-14.04,14.04-14.04v14.04h-14.04Z",
    style: {
      fill: "#fde047"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuriatko);
export default __webpack_public_path__ + "static/media/kuriatko.adc31768714ce809204064758acd3e49.svg";
export { ForwardRef as ReactComponent };